import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllOrganizations = createAsyncThunk(
  "Organization/FindAllOrganization",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/FindAllOrganization`,
        {
          OrganizationName: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Organizations:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createOrganization = createAsyncThunk(
  "Organization/InsertOrganization",
  async (OrgData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/InsertOrganization`,
        OrgData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating organization:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateOrganization = createAsyncThunk(
  "Organization/UpdateOrganization",
  async (OrgData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/UpdateOrganization`,
        OrgData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating organization:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteOrganization = createAsyncThunk(
  "Organization/DeleteOrganization",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/DeleteOrganization`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting organization:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getOrganizationByID = createAsyncThunk(
  "Organization/FindByIDOrganization",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/FindByIDOrganization`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        OrganizationName: result.OrganizationName,
        LegalName: result.LegalName,
        GSTNumber: result.GSTNumber,
        PANNumber: result.PANNumber,
        Email: result.Email,
        Phone: result.Phone,
        Website: result.Website,
        AddressLine1: result.AddressLine1,
        AddressLine2: result.AddressLine2,
        City: result.City,
        State: result.State,
        Country: result.Country,
        Pincode: result.Pincode,
        CurrencyCode: result.CurrencyCode,
        FileName: result.FileName,
        LogoImage: result.LogoImage,
        ContactPerson: result.ContactPerson,
        ContactMobile: result.ContactMobile,
        ContactEmail: result.ContactEmail,
        Crm: result.Crm,
        Hotel: result.Hotel,
        Flight: result.Flight,
        Visa: result.Visa,
        IsWebsite: result.IsWebsite,
        IsActive: result.IsActive ? 1 : 2,
      };
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching organization:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveOrganization = createAsyncThunk(
  "Organization/ActiveInActiveOrganization",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/ActiveInActiveOrganization`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive organization:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const organizationLogoUpload = createAsyncThunk(
  "Organization/UploadLogoImageOrganization",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/UploadLogoImageOrganization`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error uploading Organization Logo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateSoftwareSetting = createAsyncThunk(
  "Organization/InsertSoftwareSettingsForOrganization",
  async (OrgData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Organization/InsertSoftwareSettingsForOrganization`,
        OrgData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating software settings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
